/**
 * Test IDs for QA automation.
 */
export const testIds = {
  businessEntityInputAutocomplete: "business-entity-input-autocomplete",
  businessEntityInputAutocompleteInput:
    "business-entity-input-autocomplete-input",
  businessEntityInputAutocompleteOption:
    "business-entity-input-autocomplete-option",
} as const;
